import React from 'react';
import { useQueryState } from 'react-router-use-location-state';

import type { ViewListProps } from './list/ViewList';
/* eslint-disable-next-line import/no-cycle */
import useViewState from './components/useViewState';
import ViewList from './list/ViewList';
import DetailsSectionWrapper from '../details/components/DetailsSectionWrapper';

export default function ViewPageListTab(props: ViewListProps) {
	const [nPage, setNPage] = useQueryState('nPage', 1);
	const [nRows, setNRows] = useQueryState('nRows', 30);

	const [orderBy, setOrderBy] = useQueryState<string>('orderBy', '');
	const [orderOperator, setOrderOperator] = useQueryState<string>('orderOperator', '');

	const { paginationProps } = useViewState({
		id: props.id,
		module: props.module,
		filter: {
			defaultFilters: props.defaultFilters,
			defaultQuery: props.defaultQuery,
			filters: props.filters
		},
		order: { orderBy, setOrderBy, orderOperator, setOrderOperator },
		paginator: { nPage, setNPage, nRows, setNRows }
	});

	return (
		<DetailsSectionWrapper disablePadding>
			<ViewList
				module={props.module}
				itemLayout={props.itemLayout}
				paginationProps={paginationProps}
				refresh={props.refresh}
				updateRefresh={props.updateRefresh}
				selectionProps={props.selectionProps}
			/>
		</DetailsSectionWrapper>
	);
}
